<template>
  <div>
    <div class="sub-nav">
      <ul class="sub-nav-box">
        <li
          v-for="(nav, index) in navList"
          :key="index"
          class="sub-nav-item"
          :class="{
            pre: nav.targetRouterName === currentItem.targetRouterName,
          }"
        >
          <nav-link-item
            v-if="$route.meta.sideBar !== 'guest'"
            sub
            :nav="nav"
          />
          <nav-replace-link-item
            v-else
            sub
            :nav="nav"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import NavLinkItem from './components/NavLinkItem';
import NavReplaceLinkItem from './components/NavReplaceLinkItem';

export default {
  components: { NavLinkItem, NavReplaceLinkItem },
  props: {
    navList: {
      type: Array,
      required: true,
      default: () => [],
    },
    currentItem: {
      type: Object,
      required: true,
      default: () => ({ targetRouterName: '' }),
    },
  },
};
</script>

<style lang="scss" scoped>
.sub-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 0.6rem;
  margin-bottom: .1rem;
  .sub-nav-box {
    // width: 4.56rem;
    display: flex;
    align-items: flex-end;
    font-size: 0.22rem;
    border-bottom: 1px solid rgba(255,255,255,.2);
    box-sizing: border-box;
    height: 100%;
    margin-left: .24rem;

    .sub-nav-item {
      box-sizing: border-box;
      padding-bottom: .05rem;
      width: 1.52rem;

      &:first-child{
        margin-left: 0;
      }

      &:last-child{
        margin-right: 0;
      }

      & /deep/ .nav-link-item {
        .red-point {
          top: -0.05rem;
          right: -0.14rem;
        }
      }

      a {
        color: #fcfcfc;
        font-size: .24rem;
        width: 100%;
        display: block;
        text-align: center;
        box-sizing: border-box;
      }

      &.pre {
        // border-bottom: .02rem solid #fff;
        position: relative;
        &::after{
          content: '';
          width: 100%;
          height: 0.02rem;
          background: #fff;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }
  }
}
</style>
